export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';

export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST';
export const USER_LOGOUT = 'USER_LOGOUT';

export const GET_USER_DATA_REQUESTED = 'GET_USER_DATA_REQUESTED';
export const GET_USER_DATA_SUCCEEDED = 'GET_USER_DATA_SUCCEEDED';
export const GET_USER_DATA_FAILED = 'GET_USER_DATA_FAILED';

export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';



// WEBPACK FOOTER //
// ./src/services/user/actionTypes.js